/* eslint-disable no-nested-ternary */
import { FC, useCallback, useEffect } from 'react';
import { Box } from '@mui/material';

import { DomainTypesEnum } from './../../../../../../constants/CommonConstants';
import { useDomainType } from './../../../../../../hooks/useDomainType';
import { reportItemProgress } from '../../../MemberDetail.constants';
import { ReportFormCollapse } from '../report-form-collapse';
import { useStyles } from './StepTwo.styles';

const StepTwo = ({
  showInterference,
  selectedSymptoms,
  isLifeEvent,
  type,
  onRemoveSymptom,
  updateSymptoms,
  options,
}) => {
  const classes = useStyles();
  const [, , , lookupData] = useDomainType({
    type: DomainTypesEnum.SYMPTOMS,
  });

  const medicalConditions = lookupData?.medicalCondition;
  useEffect(() => {
    updateSymptoms(
      selectedSymptoms.map((symp, index) => ({
        ...symp,
        progress: !index ? reportItemProgress.InProgress : reportItemProgress.Incomplete,
      })),
    );
  }, []);

  const onUpdateSymptom = useCallback(
    symptom => {
      const nextIndex = selectedSymptoms.findIndex(
        item => item.item.value !== symptom.item.value && item.notes.trim().length === 0,
      );
      updateSymptoms(
        selectedSymptoms.map((symp, index) =>
          symp.item.value === symptom.item.value
            ? { ...symptom, progress: reportItemProgress.Completed }
            : index === nextIndex
            ? { ...symp, progress: reportItemProgress.InProgress }
            : symp,
        ),
      );
    },
    [selectedSymptoms, updateSymptoms],
  );

  const onRemoveClick = index => () => {
    const updatedSymptoms = selectedSymptoms.filter((_, i) => i !== index);
    onRemoveSymptom(index);
    updateSymptoms([...updatedSymptoms]);
  };

  const onOpenCollapse = symptom => open => {
    let newProgress = symptom.notes.trim().length
      ? reportItemProgress.Completed
      : reportItemProgress.Incomplete;
    if (open) {
      newProgress = reportItemProgress.InProgress;
    }

    updateSymptoms(
      selectedSymptoms.map(symp =>
        symp.item.value === symptom.item.value ? { ...symp, progress: newProgress } : symp,
      ),
    );
  };

  return (
    <Box className={classes.container}>
      {selectedSymptoms.map((symptom, index) => (
        <ReportFormCollapse
          key={index}
          symptom={symptom}
          type={type}
          isLifeEvent={isLifeEvent}
          showInterference={showInterference}
          onChange={onUpdateSymptom}
          onRemoveClick={onRemoveClick(index)}
          onOpenCollapse={onOpenCollapse(symptom)}
          options={options}
          medicalConditions={medicalConditions}
        />
      ))}
    </Box>
  );
};

export default StepTwo;
